
import React, { useEffect } from 'react';

const AskSpotWidget = () => {
  useEffect(() => {
    const loadAskSpotWidget = () => {
      fetch("https://app.askspot.ai/api/get-chatbot", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          chatbotId: "6818d3201534db28ff098aac",
          url: `${window.location.href}`,
          embedSource: "script"
        })
      })
      .then(function(e) {
        if (200 === e.status) return e.text();
        throw new Error("Error fetching data, status code: " + e.status);
      })
      .then(function(e) {
        var t = document.createElement("script");
        t.innerHTML = e;
        document.body.appendChild(t);
      })
      .catch(function(e) {
        console.error("Fetch error: ", e);
      });
    };

    loadAskSpotWidget();

    // Cleanup function to remove the widget when component unmounts
    return () => {
      // Remove any AskSpot related elements when leaving the page
      const askSpotElements = document.querySelectorAll('[id*="askspot"], [class*="askspot"]');
      askSpotElements.forEach(element => {
        element.remove();
      });
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default AskSpotWidget;
